import { useTranslate } from 'ra-core';
import { Badge } from '../../components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../components/ui/tooltip';

/** The referenced record's name, or (for several records) a count pill listing their names in a tooltip */
export const ReferenceCountPill = ({
  records,
  noun,
}: {
  records: Array<{ id: string | number; name?: string }> | undefined;
  noun: 'categories' | 'groups';
}) => {
  const translate = useTranslate();
  const names = (records ?? [])
    .map((record) => record.name)
    .filter((name): name is string => Boolean(name));

  if (names.length === 0) {
    return '—';
  }

  if (names.length === 1) {
    return names[0];
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger render={<Badge variant="secondary" tabIndex={0} />}>
          {translate(
            noun === 'categories'
              ? 'moonstar.nudges.list.categoryCount'
              : 'moonstar.nudges.list.groupCount',
            { count: names.length }
          )}
        </TooltipTrigger>
        <TooltipContent className="whitespace-pre-line">
          {names.join('\n')}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
